module.exports = __webpack_public_path__ + "img/slphouse_main7.1385d146.png";